import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import utils from 'utils';

/**
 * Remove partner rewards from reservation
 * @param data
 * @returns {Promise}
 */
export const partnerRewards = (data) => (dispatch) => {
  dispatch(
    gmiRequest({
      action: actions.request({
        method: 'POST',
        service: () => ({
          method: 'POST',
          origin: utils.config.getUrl('gmaUrl'),
          endpoint: 'reservations/partnerRewards',
          data,
        }),
      }),
    })
  );
};
